import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6aad71c9")

_pushScopeId("data-v-6aad71c9")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Invite Friends")
const _hoisted_2 = { class: "flex-1 scroll-y" }
const _hoisted_3 = { class: "main-bg p-r" }
const _hoisted_4 = { class: "c-white f-bold level-1 df-middle df-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("You get ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("You friend get")
const _hoisted_7 = { class: "lever-2 df-middle df-center c-white" }
const _hoisted_8 = {
  class: "level-2-info",
  style: {"margin-right":"72px"}
}
const _hoisted_9 = /*#__PURE__*/_createVNode("p", {
  class: "f-xl f-bold df-center df-cross-center",
  style: {"line-height":"32px","align-items":"flex-end"}
}, [
  /*#__PURE__*/_createVNode("span", { style: {"line-height":"26px"} }, "$"),
  /*#__PURE__*/_createVNode("span", { style: {"font-size":"30px"} }, "5")
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("coupon")
const _hoisted_11 = { class: "level-2-info" }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", {
  class: "f-xl f-bold df-center df-cross-center",
  style: {"line-height":"32px","align-items":"flex-end"}
}, [
  /*#__PURE__*/_createVNode("span", { style: {"line-height":"26px"} }, "$"),
  /*#__PURE__*/_createVNode("span", { style: {"font-size":"30px"} }, "5")
], -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("coupon")
const _hoisted_14 = { class: "operation__dialog-body" }
const _hoisted_15 = {
  class: "py-20",
  style: {"line-height":"20px"}
}
const _hoisted_16 = { class: "df-middle" }
const _hoisted_17 = { class: "t-center" }
const _hoisted_18 = { class: "c-title f-sm mb-16 df-cross-center" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "—", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "—", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_Button = _resolveComponent("Button")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, {
    class: "pt-8",
    "header-class": "bg-primary",
    useFooter: ""
  }, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "invite_2" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Pic, {
            src: "invite/main_bg",
            class: "img"
          }),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_t, {
              as: "div",
              path: "invite_4",
              class: "level-1-info df-cross-center",
              style: {"margin-right":"72px"}
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_t, {
              as: "div",
              path: "invite_6",
              class: "level-1-info df-cross-center"
            }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_t, {
                as: "p",
                path: "invite_5",
                class: "f-md df-cross-center"
              }, {
                default: _withId(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_t, {
                as: "p",
                path: "invite_7",
                class: "f-md df-cross-center"
              }, {
                default: _withId(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
              return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_Pic, {
                    src: step.icon,
                    width: "60",
                    height: "48",
                    class: "pr-16 pl-6"
                  }, null, 8, ["src"]),
                  _createVNode(_component_t, {
                    as: "p",
                    class: "flex-1",
                    path: step.label
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(step.labelDefault), 1)
                    ]),
                    _: 2
                  }, 1032, ["path"])
                ]),
                (index < _ctx.steps.length - 1)
                  ? (_openBlock(), _createBlock(_component_Pic, {
                      key: 0,
                      src: "invite/arrow",
                      width: "16",
                      height: "16",
                      class: "my-8 ml-32"
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("p", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_t, {
                path: "invite_12",
                class: "mr-6",
                args: {n: _ctx.invitedList.length}
              }, null, 8, ["args"]),
              _hoisted_20
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invitedList, (item) => {
              return (_openBlock(), _createBlock("p", {
                class: "mb-8 bg-background invited-list",
                key: item
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ])
      ])
    ]),
    footer: _withId(() => [
      _createVNode(_component_Button, {
        class: "btn primary df-cross-center share-btn f-bold f-lg",
        onClick: _ctx.share
      }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            path: "invite_11",
            custom: ""
          }, {
            default: _withId(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Share the link'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Pic, {
            src: "invite/share",
            width: "24",
            height: "24",
            class: "ml-6"
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
})